import React, { useEffect, useState } from "react";
import { food, menu_section_left } from "../assets/images";
import { useNavigate } from "react-router-dom";
import CreateIcon from "@mui/icons-material/Create";
import {
  useGetTablesAdminQuery,
  useLazyTableStatusChangeQuery,
} from "../constants/redux/api/api";

const TableList = ({ menuOpen }) => {
  const navigate = useNavigate();
  const [tableList, setTableList] = useState([]);

  //   RTK QUERY
  const {
    data: tableData,
    isSuccess: isTableSuccess,
    refetch: refetchTables,
  } = useGetTablesAdminQuery();
  const [tableStatusChange] = useLazyTableStatusChangeQuery();

  useEffect(() => {
    if (isTableSuccess) {
      console.log(tableData);
      setTableList(tableData?.result);
    }
  }, [tableData, isTableSuccess]);

  const onActiveClick = (item) => {
    tableStatusChange(item?._id)
      .unwrap()
      .then((res) => {
        if (res?.status === "success") {
          console.log(res);
          refetchTables();
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div
      className={menuOpen ? "side-content2" : "side-content"}
      style={{ transition: "0.5s" }}>
      <div className="menu-list d-flex align-items-center justify-content-between w-97 ">
        <h1 className="m-0">Table List</h1>
        <button
          style={{ borderColor: "#25aae1", backgroundColor: "#000" }}
          onClick={() => navigate("/add-table")}
          className="btn-outline primary1">
          + Add Table
        </button>
      </div>

      {/* table start */}
      <div className="table-responsive menu-table side_pad mt-4">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Table Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-capitalize">
            {tableList?.map((item, ind) => {
              return (
                <tr>
                  <td>{ind + 1}</td>
                  <td>{item?.table_name}</td>
                  <td>
                    <button
                      onClick={() => onActiveClick(item)}
                      className={`${
                        item?.status == 1 ? "btn-success" : "btn-danger"
                      } btn`}>
                      {item?.status == 1 ? "Active" : "De-Active"}
                    </button>
                  </td>
                  <td className="text-center">
                    <div className="btn-group">
                      <td className="text-center">
                        <div className="btn-group">
                          <button
                            onClick={() =>
                              navigate("/add-table", {
                                state: { type: "edit", data: item },
                              })
                            }
                            type="button"
                            className="btn btn-secondary">
                            <CreateIcon />
                          </button>
                          {/* <button
                          onClick={() => onClickDelete(item)}
                          type="button"
                          className="btn btn-secondary">
                          <CloseOutlinedIcon />
                        </button> */}
                        </div>
                      </td>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* table end */}
    </div>
  );
};

export default TableList;
